(function () {
    'use strict';

    angular.module('processModule')
        .controller('process-interconnected-view.controller', processInterconnectedViewController);

    processInterconnectedViewController.$inject = ['$stateParams', 'routeService', '$sce', 'pubSub'];
    function processInterconnectedViewController($stateParams, routeService, $sce, pubSub) {
        var vm = this;
        vm.initialize = initialize;
        vm.processNumber = $stateParams.processNumber;
        vm.processInterconnectedViewIframe = '';


        initialize();

        function initialize() {
            vm.processInterconnectedViewIframe = $sce.trustAsResourceUrl(routeService.getBaseRouteProcess() + 'process-interconnected/management/' + vm.processNumber + '?isFrontend=true');

            pubSub.publish(broadcastType.processAreaRouteChanged, {
                processNumber: vm.processNumber,
                processClassification: E.processClassificationTypes.ProcessInterconnected
            });

            angular.element(".main-container_body").css({
                overflowY: 'hidden'
            });
        }
    }
})();

